export const COM_LOADING = 'COM_LOADING'
export const COM_ZOOM = 'COM_ZOOM'
export const COM_VISIBLE = 'COM_VISIBLE'

export const CITY_LIST = 'CITY_LIST'
export const STREET_LIST = 'STREET_LIST'
export const TYPE_LIST = 'TYPE_LIST'
export const LAW_LIST = 'LAW_LIST'



// WEBPACK FOOTER //
// ./src/vuex/types.js